import * as types from '../store/types';
import resources from '../helpers/resources';
import select from '../store/selectors';
import validate from '../store/validators';

function verificationSuccess(resp) {
  return {
    type: types.VERIFICATION_SUCCESS,
    payload: resp,
  };
}

export default function verifyPayment() {
  return async (dispatch, getState) => {
    const state = getState();
    const selector = select(state);
    const validator = validate(state);

    const { id: shopId, orderUnique } = selector.getShop();

    if (orderUnique && validator.invoiceCreated()) {
      const {
        result: { data: resultData },
        id: createdInvoiceId,
      } = selector.getInvoice();

      if (
        createdInvoiceId !== null &&
        resultData != null &&
        resultData.id != null &&
        createdInvoiceId === resultData.id
      ) {
        let e = new Error('Already paid');
        e.type = 'alreadyPaid';
        throw e;
      }

      let e = new Error('Already created');
      e.type = 'alreadyCreated';
      throw e;
    }

    if (validator.isPaymentVerified()) {
      let e = new Error('Already verified');
      e.type = 'alreadyVerified';
      throw e;
    }

    if (!validator.isPaymentValid()) {
      let e = new Error('Invalid payment');
      e.type = 'invalidPayment';
      throw e;
    }

    const {
      shopOrderId,
      amount,
      currency: { id: currencyId },
      sign,
    } = selector.getPayment();

    const resp = await resources().verify({
      shopOrderId,
      shopId,
      amount,
      currency: currencyId,
      sign,
    });

    dispatch(verificationSuccess(resp.data));

    return resp;
  };
}
